import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface SmsDraft {
  id?: number;
  name: string;
  recipients: string;
  message: string;
  ward_filter?: any;
  is_favorite?: boolean;
  last_used?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface SmsDraftResponse {
  drafts: SmsDraft[];
  total: number;
  current_page: number;
  total_pages: number;
  per_page: number;
}

export interface SmsDraftStats {
  total_drafts: number;
  favorite_drafts: number;
  last_used: Date | null;
}

@Injectable({
  providedIn: 'root'
})
export class SmsDraftService {
  private baseUrl = `${environment.apiBaseUrl}/api/sms-draft`;

  constructor(private http: HttpClient) { }

  // Create new draft
  createDraft(draft: SmsDraft): Observable<any> {
    return this.http.post(this.baseUrl, draft);
  }

  // Get all drafts with pagination and filters
  getAllDrafts(page: number = 1, limit: number = 10, search: string = '', favoritesOnly: boolean = false): Observable<SmsDraftResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    
    if (search) {
      params = params.set('search', search);
    }
    
    if (favoritesOnly) {
      params = params.set('favorites_only', 'true');
    }

    return this.http.get<SmsDraftResponse>(this.baseUrl, { params });
  }

  // Get single draft by ID
  getDraftById(id: number): Observable<SmsDraft> {
    return this.http.get<SmsDraft>(`${this.baseUrl}/${id}`);
  }

  // Update draft
  updateDraft(id: number, draft: Partial<SmsDraft>): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, draft);
  }

  // Delete draft
  deleteDraft(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  // Toggle favorite status
  toggleFavorite(id: number): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${id}/favorite`, {});
  }

  // Get draft statistics
  getDraftStats(): Observable<SmsDraftStats> {
    return this.http.get<SmsDraftStats>(`${this.baseUrl}/stats/summary`);
  }

  // Quick save (creates or updates based on ID)
  quickSave(draft: SmsDraft): Observable<any> {
    if (draft.id) {
      return this.updateDraft(draft.id, draft);
    } else {
      return this.createDraft(draft);
    }
  }
} 